import { Icon } from '@fluentui/react';
import React from 'react';
import ReactApexChart from "react-apexcharts";
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { isNullUndefined } from '../../../../../../common/Helpers';

function ChartGauge(props) {
const { t, i18n } = useTranslation();

const { 
	inputParam_ComponentContent = null,
	selectedGaugeDataPointIndex = null
} = props;


const indexStart = inputParam_ComponentContent !== null ? ((selectedGaugeDataPointIndex !== null && selectedGaugeDataPointIndex !== undefined) ? selectedGaugeDataPointIndex : (inputParam_ComponentContent.l_dataserie === undefined ? inputParam_ComponentContent.l_vals.length -1 : inputParam_ComponentContent.l_dataserie[0].l_vals.length -1)) : undefined
const indexEnd = inputParam_ComponentContent !== null ? ((selectedGaugeDataPointIndex !== null && selectedGaugeDataPointIndex !== undefined) ? (selectedGaugeDataPointIndex  -1): (inputParam_ComponentContent.l_dataserie === undefined ? inputParam_ComponentContent.l_vals.length -2 : inputParam_ComponentContent.l_dataserie[0].l_vals.length -2)) : undefined

const variationstr = indexStart !== null && indexStart !== undefined ? (indexEnd < 0 ? t('data-lang-lbl-nopreviousdata') : (
	inputParam_ComponentContent.l_dataserie === undefined ? 
	((inputParam_ComponentContent.l_vals[indexStart].valueGoalPercent - inputParam_ComponentContent.l_vals[indexEnd].valueGoalPercent).toLocaleString(i18n.language) + "%") :
	(inputParam_ComponentContent.l_dataserie[0].l_vals.length > 0 ? (((isNullUndefined(inputParam_ComponentContent.l_dataserie[0].l_vals[indexStart]) ? 0 : inputParam_ComponentContent.l_dataserie[0].l_vals[indexStart].valueGoalPercent) - inputParam_ComponentContent.l_dataserie[0].l_vals[indexEnd].valueGoalPercent).toLocaleString(i18n.language) + "%") : '--')
)) : t('data-lang-lbl-nopreviousdata')

const variation = indexStart !== null && indexStart !== undefined ? (indexEnd < 0 ? 0 : (
	inputParam_ComponentContent.l_dataserie === undefined ? 
	(inputParam_ComponentContent.l_vals[indexStart].valueGoalPercent - inputParam_ComponentContent.l_vals[indexEnd].valueGoalPercent) :
	((isNullUndefined(inputParam_ComponentContent.l_dataserie[0].l_vals[indexStart]) ? 0 : inputParam_ComponentContent.l_dataserie[0].l_vals[indexStart].valueGoalPercent) - inputParam_ComponentContent.l_dataserie[0].l_vals[indexEnd].valueGoalPercent)
)) : 0

const previousValue = indexStart !== null && indexStart !== undefined ? (indexEnd < 0 ? 0 : (inputParam_ComponentContent.l_dataserie === undefined ? inputParam_ComponentContent.l_vals[indexStart].valueGoalPercent :  (isNullUndefined(inputParam_ComponentContent.l_dataserie[0].l_vals[indexStart]) ? 0 : inputParam_ComponentContent.l_dataserie[0].l_vals[indexStart].valueGoalPercent))) : 0
const serieTime = indexStart !== null && indexStart !== undefined ? (indexEnd < 0 ? '' : (inputParam_ComponentContent.l_dataserie === undefined ? inputParam_ComponentContent.l_vals[indexStart].serieTimeStr : (isNullUndefined(inputParam_ComponentContent.l_dataserie[0].l_vals[indexStart]) ? '' : inputParam_ComponentContent.l_dataserie[0].l_vals[indexStart].serieTimeStr))) : ''
const color = indexStart !== null && indexStart !== undefined ? (indexEnd < 0 ? 'gray' : (inputParam_ComponentContent.l_dataserie === undefined ? inputParam_ComponentContent.l_vals[indexStart].color : (isNullUndefined(inputParam_ComponentContent.l_dataserie[0].l_vals[indexStart]) ? 'gray' : inputParam_ComponentContent.l_dataserie[0].l_vals[indexStart].color))) : 'gray'

const valorOriginal = previousValue;
const valorMaximo = inputParam_ComponentContent !== null ? (inputParam_ComponentContent.l_dataserie === undefined ? inputParam_ComponentContent.lmax : (inputParam_ComponentContent.l_dataserie.length > 0 ? inputParam_ComponentContent.l_dataserie[0].lmax : 0)) : 0;
const aux_valorEscalar = inputParam_ComponentContent !== null ? (valorOriginal / valorMaximo) * 100 : 0;
const valorEscalar = !isNaN(aux_valorEscalar) ? aux_valorEscalar : 0;

const options = {
	title: {
		text: t('data-lang-lbl-goalpercent'),
		align: 'center',
	},
	subtitle: {
		text: serieTime,
		align: 'center',
	},
	chart: {
		type: 'radialBar',
		offsetY: -20,
		sparkline: {
			enabled: true
		},
		height: 300
	},
	plotOptions: {
		radialBar: {
			startAngle: -90,
			endAngle: 90,
			track: {
				background: "#e7e7e7",
				strokeWidth: '97%',
				margin: 5,
				dropShadow: {
					enabled: true,
					top: 2,
					left: 0,
					color: '#999',
					opacity: 1,
					blur: 2
				}
			},
			dataLabels: {
				name: {
				show: false
				},
				value: {
					offsetY: -2,
					fontSize: '22px',
					show : false,
				}
			}
		}
	},
	colors: [color === 'r' ? '#d93b3b' : (color === 'v' ? '#25aa34' : (color === 'a' ? '#ECA700' : '#999999'))],
	grid: {
		padding: {
			top: -10
		}
	},
	fill: {
		type: 'solid',
		colors: [color === 'r' ? '#d93b3b' : (color === 'v' ? '#25aa34' : (color === 'a' ? '#ECA700' : '#999999'))], // Establecer el color de relleno
	},
}

return (<>
		{
			inputParam_ComponentContent &&
			<Col xl={4} className='my-auto'>
				<Row>
					<Col>
						<ReactApexChart
							options={options}
							series={[valorEscalar]}
							type="radialBar"
							height={300} />
					</Col>
				</Row>
				<Row style={{ marginTop: "-40px" }}>
					<Col>
						<Row>
							<Col className='col-auto mx-auto'>
								<h6>{`${t('data-lang-lbl-total')} ${ valorOriginal !== null ? valorOriginal.toLocaleString(i18n.language) : '--' }`}</h6>
							</Col>
						</Row>
						<Row>
							<Col className='d-flex col-auto mx-auto'>
									<h6><b>{`${t('data-lang-lbl-variation')}`}</b>:</h6>
									&nbsp;&nbsp;
									{
										variationstr !== t('data-lang-lbl-nopreviousdata') &&
										<>
											<Icon
												iconName={ variation > 0 ? 'FlickDown' : (variation < 0 ? 'FlickUp' : 'ToggleFilled') }
												className='my-auto'
												style={
													variation > 0 ? 
														{color: "#25aa34", position: "relative", bottom: "7px"} :
														(
															variation < 0 ?
																{color: "#d93b3b", position: "relative", top: "2px"} :
																{color: "#999999", position: "relative", bottom: "2px"}
														)
												}
											/>&nbsp;
										</>
									}
									
									<h6><b>{`${ variationstr }`}</b></h6>
							</Col>
						</Row>
					</Col>
				</Row>
			</Col>
		}
		</>);
};

export default ChartGauge;